import Dotdotdot from "react-dotdotdot";
import ProgressStatusCircle from "shared/components/feedback/progress-status-circle/ProgressStatusCircle";
import PropTypes from "prop-types";
import { Container, Name, StyledProjectRow } from "./ProjectDetail.styles";

const ProjectDetail = ({ ...props }) => {
    return (
        <Container className={props.className}>
            <StyledProjectRow
                SOWValue={props.sowValue}
                projectName={props.name}
                SOWTitle={props.sowStatus}
            >
                <ProgressStatusCircle
                    value={props.sowValue}
                    title={props.sowStatus}
                />
                <Dotdotdot clamp={1}>
                    <Name
                        SOWValue={props.sowValue}
                        projectName={props.name}
                        SOWTitle={props.sowStatus}
                        {...props}
                    >
                        {props.name}
                    </Name>
                </Dotdotdot>
            </StyledProjectRow>
        </Container>
    );
};

ProjectDetail.defaultProps = {
    name: "project name",
};

ProjectDetail.propTypes = {
    name: PropTypes.string,
    sowValue: PropTypes.number,
    sowStatus: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.bool,
};

export default ProjectDetail;
